<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Email newsletter</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Iscritti newsletter</h2>
            <span class="ac-meta">indirizzi email registrati</span>
        </div>
        <a class="acc-btn acc-btn-primary" routerLink="/backoffice/newsletter/add">
            <i class="bi bi-plus"></i>
            Aggiungi email
        </a>
    </div>

    <p-table #dt
        [exportFilename]="'newsletters'"
        [columns]="[{field: 'email', header: 'Email'}]"
        [loading]="loading"
        [value]="newsletters"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['email']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} email newsletter"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full">
                <div class="lg:w-3/4 w-full">
                    <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                        <p-inputicon styleClass="bi bi-search" />
                        <input type="text" pInputText (input)="onGlobalFilter(dt, $event)" placeholder="Cerca email…" [style]="{'width': '100%'}" />
                    </p-iconfield>
                </div>
                <div class="lg:w-1/4 w-full table-toolbar-btns">
                    <button class="flex-1 acc-btn" type="button" (click)="dt.exportCSV()">
                        <i class="bi bi-file-spreadsheet"></i>
                        Esporta
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="email">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-newsletter>
            <tr>
                <td>
                    <span class="p-column-title">Email</span>
                    <span class="cell-nome">{{newsletter.email}}</span>
                </td>
                <td class="text-center">
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/newsletter/' + newsletter.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteNewsletter>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteNewsletter()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteNewsletter()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteNewsletter($event, newsletter)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2">Nessuna email della newsletter trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
